const styles = {
  wrapperSx: {
    mt: "20px",
    overflow: "hidden",
  },

  slideStyle: { width: "min(380px, calc((100vw - 32px) * 10 / 12))" },

  navRowSx: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    gap: 3,
    mt: 2,
  },

  navButtonSx: {
    color: "white",
    border: "1px solid rgba(255,255,255,0.3)",
    borderRadius: "8px",
    padding: "10px",
    "& svg": { fontSize: "2rem" },
    transition: "all 0.2s",
    "&:hover": {
      backgroundColor: "rgba(255,255,255,0.12)",
      borderColor: "rgba(255,255,255,0.6)",
    },
    "&:focus, &:focus-visible": {
      outline: "none",
      boxShadow: "none",
    },
  },
};

export default styles;
